import { Component, ViewChild, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { UserService } from "../service/user.service";
import { ModalPatientDetailComponent } from "../modals/modal-patient-detail/modal-patient-detail.component";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import { ModalPatientMedicationDetailComponent } from "../modals/modal-patient-medication-detail/modal-patient-medication-detail.component";
import { ModalNewPatientMedicationComponent } from "../modals/modal-new-patient-medication/modal-new-patient-medication.component";
import { DoctorService } from "../service/doctor.service";
import { ModalMessageComponent } from "../modals/modal-message/modal-message.component";
import { MatSort } from "@angular/material/sort";
import { ModalPatientResponsablesComponent } from "../modals/modal-patient-responsables/modal-patient-responsables.component";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  selector: "app-patients",
  templateUrl: "./patients.component.html",
  styleUrls: ["./patients.component.css"],
})
export class PatientsComponent implements OnDestroy {
  isSecretary = false;

  // Debounce para o filtro
  private filterSubject = new Subject<string>();

  // Cache para dados processados
  private processedData: any[] = [];
  private lastFilterText = "";

  // Estado de loading para o filtro
  isSearching = false;

  // Estados para carregamento híbrido
  isLoadingFromCache = false;
  isLoadingFromAPI = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private modalService: MDBModalService,
    private doctorService: DoctorService
  ) {
    const d = localStorage.getItem("doctor");
    if (d) {
      const aux = JSON.parse(d);
      if (aux.specialty === 23) this.isSecretary = true;
    }

    // Configurar debounce para o filtro
    this.filterSubject
      .pipe(
        debounceTime(300), // Aguarda 300ms após o último caracter digitado
        distinctUntilChanged() // Só executa se o valor mudou
      )
      .subscribe((filterText) => {
        this.performFilter(filterText);
      });
  }
  company_type = localStorage.getItem("companyType");
  displayedColumns: string[] = [
    "name",
    "birthDate",
    "gender",
    "association",
    "active",
    "option",
  ];
  data_source = new MatTableDataSource<any>([]);

  modalRef: MDBModalRef;
  modalRef2: MDBModalRef;

  /* pagination related variabels */
  page: number = 1;
  count_total: number = 0;
  page_count1: number = 0;
  page_count2: number = 0;
  page_size = 50;

  is_loaded: boolean = false;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  filter = true;
  filterText = "";
  allData = [];

  ngOnInit() {
    // Monitorar uso do localStorage na inicialização
    this.monitorStorageUsage();

    if (localStorage.getItem("token") == null) {
      this.router.navigate(["/login"]);
    } else if (
      localStorage.getItem("admin") == "true" &&
      localStorage.getItem("company") == null
    ) {
      this.router.navigate(["/home/doctors"]);
    } else {
      // Usar carregamento híbrido para melhor UX
      this.loadPatientsWithCache(1);
    }
  }

  getPatients(page, search = null) {
    // Se for primeira chamada, usar carregamento híbrido
    if (page === 1 && !search && this.allData.length === 0) {
      this.loadPatientsWithCache(page);
      return;
    }

    // Para outras situações, usar API diretamente
    this.loadFromAPI(page);
  }

  next() {
    if (this.page_count2 < this.count_total && this.is_loaded) {
      // this.data_source.data = [];
      // this.data_source.sort = this.sort;
      // this.is_loaded = false;
      this.page = this.page + 1;
      this.page_count1 = 1 + (this.page - 1) * this.page_size;
      if (this.page_count1 + (this.page_size - 1) > this.count_total) {
        this.page_count2 = this.count_total;
      } else {
        this.page_count2 = this.page_count1 + (this.page_size - 1);
      }
      this.data_source.data = this.allData.slice(
        this.page_count1 - 1,
        this.page_count2
      );
      this.data_source.sort = this.sort;
      // this.getPatients(this.page + 1);
    }
  }

  prev() {
    if (this.page > 1 && this.is_loaded) {
      // this.data_source.data = [];
      // this.data_source.sort = this.sort;
      this.page = this.page - 1;
      this.page_count1 = 1 + (this.page - 1) * this.page_size;
      if (this.page_count1 + (this.page_size - 1) > this.count_total) {
        this.page_count2 = this.count_total;
      } else {
        this.page_count2 = this.page_count1 + (this.page_size - 1);
      }
      this.data_source.data = this.allData.slice(
        this.page_count1 - 1,
        this.page_count2
      );
      this.data_source.sort = this.sort;
      // this.is_loaded = false;
      // this.getPatients(this.page - 1);
    }
  }

  openNewPatientMedication(patient) {
    this.modalRef = this.modalService.show(ModalNewPatientMedicationComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: "Adicionar Medicamento",
        btn_text: "Adicionar",
        is_new: true,
        isPatient: patient,
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result == "update") {
        this.getPatients(this.page);
      }
    });
  }

  openPatientMedicationDetail(patient) {
    this.modalRef = this.modalService.show(
      ModalPatientMedicationDetailComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true,
        ignoreBackdropClick: true,
        class: "modal-dialog-centered modal-dialog",
        containerClass: "",
        animated: false,
        data: {
          title: "Medicamentos",
          btn_text: "Fechar",
          is_new: true,
          isPatient: patient,
        },
      }
    );
    this.modalRef.content.action.subscribe((result: any) => {
      if (result == "update") {
        this.getPatients(this.page);
      }
    });
  }

  newPatient() {
    this.modalRef = this.modalService.show(ModalPatientDetailComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-lg modal-size",
      containerClass: "",
      animated: false,
      data: {
        title: "Adicionar Paciente",
        btn_text: "Adicionar",
        is_new: true,
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result == "update") {
        this.getPatients(this.page);
      }
    });
  }

  newCode() {
    this.doctorService.getIntegrationCode().subscribe(
      (data) => {
        if (!data || !data.code) {
          this.openMessage(
            "Erro",
            "Ocorreu um erro ao tentar gerar o código, tente novamente mais tarde!",
            false
          );
        } else {
          this.openMessage(
            "Sucesso",
            `Código gerado com sucesso, informe ao seu paciente para ele realizar o vínculo. (Código: ${data.code})`,
            false
          );
        }
        //console.log(data);
      },
      (err) => {
        this.openMessage(
          "Erro",
          "Ocorreu um erro ao tentar gerar o código, tente novamente mais tarde!",
          false
        );
      }
    );
  }

  seeResponsibles(patient) {
    {
      this.modalRef = this.modalService.show(
        ModalPatientResponsablesComponent,
        {
          backdrop: true,
          keyboard: true,
          focus: true,
          show: true,
          ignoreBackdropClick: true,
          class: "modal-dialog-centered modal-dialog modal-lg modal-size",
          containerClass: "",
          animated: false,
          data: {
            title: "Responsáveis do paciente - " + patient.name,
            btn_text: "Salvar",
            is_new: false,
            patient_clone: patient,
          },
        }
      );
    }
  }

  editPatient(patient) {
    this.modalRef = this.modalService.show(ModalPatientDetailComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-lg modal-size",
      containerClass: "",
      animated: false,
      data: {
        title: "Editar Paciente",
        btn_text: "Salvar",
        is_new: false,
        patient_clone: patient,
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result == "update") {
        this.getPatients(this.page);
      }
    });
  }

  openMessage(title, text, bgclick: boolean) {
    this.modalRef2 = this.modalService.show(ModalMessageComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: bgclick,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: title,
        text: text,
      },
    });
  }

  getAssocition(patient) {
    const company = localStorage.getItem("company");
    if (
      company &&
      patient &&
      patient.company &&
      Number(company) === Number(patient.company.id)
    ) {
      return patient.company.name;
    }
    return "Independente";
  }

  changeStatus(id, is_active) {
    this.userService.editPatientActived(id, is_active).subscribe(
      (data) => {},
      (error) => {
        this.error(error, "editar");
      }
    );
  }

  error(error, string) {
    var msg = "";
    if (
      error.error != null &&
      error.error.error != null &&
      error.error.error.length < 50
    )
      msg = error.error.error;
    else msg = "Por favor verifique as informações inseridas";
    this.openMessage(
      `Erro, não foi possível ${string} o paciente.`,
      msg,
      false
    );
  }

  changeFilter(filter) {
    this.filter = filter;
    this.is_loaded = false;
    this.getPatients(1);
  }

  getStyle(cur) {
    if (this.filter === cur) return "bold";
    return "normal";
  }

  accentFold(inStr) {
    return inStr.replace(
      /([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
      function (str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return "a";
        if (c) return "c";
        if (e) return "e";
        if (i) return "i";
        if (n) return "n";
        if (o) return "o";
        if (s) return "s";
        if (u) return "u";
        if (y) return "y";
        if (ae) return "ae";
      }
    );
  }

  makeFilter() {
    // Ativar estado de loading se há texto para pesquisar
    if (this.filterText && this.filterText.trim().length > 0) {
      this.isSearching = true;
    } else {
      // Se não há texto, limpar loading imediatamente
      this.isSearching = false;
    }

    // Usar debounce em vez de executar imediatamente
    this.filterSubject.next(this.filterText);
  }

  // Pré-processar dados para otimizar buscas
  private preprocessData() {
    this.processedData = this.allData.map((item) => ({
      ...item,
      searchText: this.accentFold(item.name.toLowerCase()),
    }));
  }

  // Função otimizada de filtro com debounce
  private performFilter(filterText: string) {
    let data = [];

    if (!filterText || !filterText.trim().length) {
      data = this.allData;
    } else {
      const searchTerm = this.accentFold(filterText.toLowerCase());

      // Usar dados pré-processados para busca mais rápida
      data = this.allData.filter((item, index) => {
        const processedItem = this.processedData[index];
        return processedItem && processedItem.searchText.includes(searchTerm);
      });
    }

    // Atualizar paginação
    this.updatePagination(data);

    // Atualizar dados da tabela
    this.data_source.data = data.slice(this.page_count1 - 1, this.page_count2);
    this.data_source.sort = this.sort;

    this.lastFilterText = filterText;

    // Desativar estado de loading
    this.isSearching = false;
  }

  // Função auxiliar para atualizar paginação
  private updatePagination(data: any[]) {
    this.page = 1;
    this.count_total = data.length;
    this.page_count1 = 1;

    if (this.page_size > this.count_total) {
      this.page_count2 = this.count_total;
    } else {
      this.page_count2 = this.page_size;
    }
  }

  ngOnDestroy() {
    // Limpar subscription do debounce
    this.filterSubject.complete();
  }

  // Função para otimizar dados dos pacientes antes de armazenar
  private optimizePatientsForStorage(patients: any[]): any[] {
    return patients.map((patient) => ({
      id: patient.id,
      name: patient.name,
      birthDate: patient.birthDate,
      gender: patient.gender,
      is_active: patient.is_active,
      birthday: patient.birthday,
      email: patient.email,
      blood_type: patient.blood_type,
      phone: patient.phone,

      health_insurance: patient.health_insurance,

      city: patient.city,
      cep: patient.cep,
      number: patient.number,
      complement: patient.complement,
      state: patient.state,
      street: patient.street,
      neighborhood: patient.neighborhood,

      config_glucose_maximo: patient.config_glucose_maximo,
      config_glucose_minimo: patient.config_glucose_minimo,
      config_glucose_minutes: patient.config_glucose_minutes,
      config_heartbeat_maximo: patient.config_heartbeat_maximo,
      config_heartbeat_minimo: patient.config_heartbeat_minimo,
      config_heartbeat_minutes: patient.config_heartbeat_minutes,
      config_oxygenation_maximo: patient.config_oxygenation_maximo,
      config_oxygenation_minimo: patient.config_oxygenation_minimo,
      config_oxygenation_minutes: patient.config_oxygenation_minutes,
      config_pressure_diastolica_maximo:
        patient.config_pressure_diastolica_maximo,
      config_pressure_diastolica_minimo:
        patient.config_pressure_diastolica_minimo,
      config_pressure_sistolica_maximo:
        patient.config_pressure_sistolica_maximo,
      config_pressure_sistolica_minimo:
        patient.config_pressure_sistolica_minimo,
      config_respiratoryFrequency_maximo:
        patient.config_respiratoryFrequency_maximo,
      config_respiratoryFrequency_minimo:
        patient.config_respiratoryFrequency_minimo,
      config_temperature_maximo: patient.config_temperature_maximo,
      config_temperature_minimo: patient.config_temperature_minimo,
      config_temperature_minutes: patient.config_temperature_minutes,

      user: {
        id: patient.user.id,
        is_active: patient.user.is_active,
        cpf: patient.user.cpf,
      },
      company: patient.company
        ? {
            id: patient.company.id,
            name: patient.company.name,
          }
        : null,
      // Remover campos desnecessários para economizar espaço
      // Como emails longos, descrições, logs, etc.
    }));
  }

  // Função para lidar com quota excedida do localStorage
  private handleStorageQuotaExceeded(data: any[]) {
    try {
      // Estratégia 1: Limpar localStorage antigo
      this.clearOldStorageData();

      // Estratégia 2: Tentar salvar versão ultra-otimizada
      const minimalData = this.getMinimalPatientData(data);
      localStorage.setItem("patients", JSON.stringify(minimalData));

      console.info(
        "Dados salvos em versão otimizada devido a limitação de espaço"
      );
    } catch (error) {
      // Estratégia 3: Salvar apenas IDs essenciais
      try {
        const idsOnly = data.map((p) => ({ id: p.id, name: p.name }));
        localStorage.setItem("patients_minimal", JSON.stringify(idsOnly));
        console.warn(
          "Salvando apenas dados essenciais devido a limitação de espaço"
        );
      } catch (finalError) {
        console.error(
          "Não foi possível salvar dados no localStorage:",
          finalError
        );
        // Opcionalmente, usar IndexedDB ou outra alternativa
        this.notifyStorageIssue();
      }
    }
  }

  // Função para monitorar e reportar uso do localStorage
  monitorStorageUsage() {
    const info = this.checkStorageSpace();
    const usagePercent = (info.used / info.total) * 100;

    console.log(
      `📊 localStorage Usage: ${usagePercent.toFixed(1)}% (${(
        info.used /
        1024 /
        1024
      ).toFixed(2)}MB / ${(info.total / 1024 / 1024).toFixed(2)}MB)`
    );

    // Alertar se o uso estiver muito alto
    if (usagePercent > 80) {
      console.warn(
        "⚠️ localStorage quase cheio! Considere limpar dados antigos."
      );

      if (usagePercent > 95) {
        this.performEmergencyCleanup();
      }
    }

    return { usagePercent, info };
  }

  // Limpeza de emergência quando localStorage está quase cheio
  private performEmergencyCleanup() {
    console.log("🧹 Executando limpeza de emergência do localStorage...");

    // Remover dados temporários e caches antigos
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key &&
        (key.includes("cache_") ||
          key.includes("temp_") ||
          key.includes("backup_") ||
          key.includes("log_") ||
          key.startsWith("angular-"))
      ) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
      console.log(`🗑️ Removido: ${key}`);
    });

    console.log(
      `✅ Limpeza concluída. ${keysToRemove.length} itens removidos.`
    );
  }

  // Função para limpar dados antigos do localStorage
  private clearOldStorageData() {
    const keysToRemove = [];

    // Identificar chaves antigas que podem ser removidas
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key &&
        (key.includes("cache_") ||
          key.includes("temp_") ||
          key.includes("old_"))
      ) {
        keysToRemove.push(key);
      }
    }

    // Remover chaves identificadas
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  }

  // Função para dados mínimos dos pacientes
  private getMinimalPatientData(patients: any[]): any[] {
    return patients.map((patient) => ({
      id: patient.id,
      name: patient.name,
      active: patient.is_active,
      // Manter apenas dados absolutamente essenciais
    }));
  }

  // Função para notificar sobre problemas de armazenamento
  private notifyStorageIssue() {
    this.openMessage(
      "Aviso",
      "Muitos dados para armazenar localmente. Algumas funcionalidades offline podem ser limitadas.",
      false
    );
  }

  // Função para verificar espaço disponível no localStorage
  private checkStorageSpace(): {
    used: number;
    available: number;
    total: number;
  } {
    let used = 0;
    for (let key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        used += localStorage[key].length + key.length;
      }
    }

    const total = 5 * 1024 * 1024; // Aproximadamente 5MB (varia por navegador)
    const available = total - used;

    return { used, available, total };
  }

  // Função para recuperar dados dos pacientes do localStorage
  getPatientsFromStorage(): any[] {
    try {
      // Tentar recuperar dados completos primeiro
      const fullData = localStorage.getItem("patients");
      if (fullData) {
        return JSON.parse(fullData);
      }

      // Fallback para dados mínimos se não houver dados completos
      const minimalData = localStorage.getItem("patients_minimal");
      if (minimalData) {
        console.info("Recuperando dados em versão otimizada");
        return JSON.parse(minimalData);
      }

      return [];
    } catch (error) {
      console.error("Erro ao recuperar dados do localStorage:", error);
      return [];
    }
  }

  // Função para limpar completamente o cache de pacientes
  clearPatientsCache() {
    localStorage.removeItem("patients");
    localStorage.removeItem("patients_minimal");
    console.info("Cache de pacientes limpo");
  }

  // Carregamento híbrido: cache primeiro, API depois
  loadPatientsWithCache(page: number) {
    console.log("🔄 Iniciando carregamento híbrido...");

    // 1. Tentar carregar do cache primeiro
    this.loadFromCache();

    // 2. Sempre buscar dados atualizados da API
    this.loadFromAPI(page);
  }

  // Carregar dados do cache
  private loadFromCache() {
    try {
      this.isLoadingFromCache = true;
      const cachedData = this.getPatientsFromStorage();

      if (cachedData && cachedData.length > 0) {
        console.log(`📦 ${cachedData.length} pacientes carregados do cache`);
        this.displayData(cachedData, "cache");
        this.is_loaded = true;
      }
    } catch (error) {
      console.warn("Erro ao carregar cache:", error);
    } finally {
      this.isLoadingFromCache = false;
    }
  }

  // Carregar dados da API
  private loadFromAPI(page: number) {
    this.isLoadingFromAPI = true;

    this.userService.getPatientsPagination(page, this.filter).subscribe(
      (apiData) => {
        try {
          console.log(`🌐 ${apiData.length} pacientes recebidos da API`);

          // Filtrar apenas pacientes
          const filteredData = apiData.filter(
            (item) => item.is_doctor === false
          );

          // Verificar se dados são diferentes do cache
          if (this.shouldUpdateData(filteredData)) {
            console.log("🔄 Atualizando dados com informações da API");
            this.displayData(filteredData, "api");
            this.saveDataToStorage(filteredData);
          } else {
            console.log("✅ Dados da API são iguais ao cache");
          }
        } catch (error) {
          console.error("Erro ao processar dados da API:", error);
        } finally {
          this.isLoadingFromAPI = false;
          this.is_loaded = true;
        }
      },
      (error) => {
        console.error("❌ Erro na API:", error);
        this.isLoadingFromAPI = false;

        // Se não temos dados do cache e API falha, redirecionar
        if (this.allData.length === 0) {
          localStorage.removeItem("token");
          this.router.navigate(["/login"]);
        }
      }
    );
  }

  // Exibir dados na interface
  private displayData(data: any[], source: "cache" | "api") {
    // Configurar paginação
    this.page = 1;
    this.count_total = data.length;
    this.page_size = 50;
    this.page_count1 = 1;
    this.page_count2 = Math.min(this.page_size, this.count_total);

    // Ordenar e armazenar dados
    data.sort((a, b) => a.name.localeCompare(b.name));
    this.allData = data;

    // Pré-processar para filtros
    this.preprocessData();

    // Atualizar tabela
    this.data_source.data = data.slice(0, this.page_count2);
    this.data_source.sort = this.sort;

    console.log(`✅ Interface atualizada com dados do ${source}`);
  }

  // Verificar se deve atualizar dados
  private shouldUpdateData(newData: any[]): boolean {
    // Se não há dados atuais, sempre atualizar
    if (this.allData.length === 0) {
      return true;
    }

    // Se tamanhos diferentes, atualizar
    if (this.allData.length !== newData.length) {
      return true;
    }

    // Comparação simples por IDs
    const currentIds = this.allData.map((item) => item.id).sort();
    const newIds = newData.map((item) => item.id).sort();

    return JSON.stringify(currentIds) !== JSON.stringify(newIds);
  }

  // Salvar dados no storage
  private saveDataToStorage(data: any[]) {
    try {
      const storageInfo = this.checkStorageSpace();
      const dataSize = JSON.stringify(data).length;

      if (dataSize > storageInfo.available) {
        const optimizedData = this.optimizePatientsForStorage(data);
        localStorage.setItem("patients", JSON.stringify(optimizedData));
        console.log("💾 Dados otimizados salvos no cache");
      } else {
        localStorage.setItem("patients", JSON.stringify(data));
        console.log("💾 Dados completos salvos no cache");
      }
    } catch (ex) {
      console.warn("⚠️ Erro ao salvar cache:", ex);
      this.handleStorageQuotaExceeded(data);
    }
  }

  // Função para forçar atualização dos dados
  forceRefresh() {
    console.log("🔄 Forçando atualização dos dados...");
    this.clearPatientsCache();
    this.loadPatientsWithCache(1);
  }

  // Getter para verificar se está carregando
  get isLoading(): boolean {
    return this.isLoadingFromCache || this.isLoadingFromAPI;
  }

  // Limpar dados e forçar recarga
  refreshData() {
    this.clearPatientsCache();
    this.allData = [];
    this.data_source.data = [];
    this.loadPatientsWithCache(1);
  }
}
